import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaDisciplinasLayer from "../components/ListaDisciplinasLayer";
import { useTranslation } from "../i18n/I18nContext";

const DisciplinasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("disciplina.breadcrumb.list")} />
      <ListaDisciplinasLayer />
    </MasterLayout>
  );
};

export default DisciplinasPage;
